import { tenant } from '@tenant';

import type { WebhookCreatorType } from 'api';

export const WEBHOOK_DETAILS_TEST_ID = 'developers_webhooks_details';
export const WEBHOOK_DETAILS_CLOSE_TEST_ID =
  'developers_webhooks_details_close-btn';
export const WEBHOOK_DETAILS_STATUS_TEST_ID =
  'developers_webhooks_details_status-label';
export const WEBHOOK_DETAILS_ENDPOINT_TEST_ID =
  'developers_webhooks_details_endpoint-label';
export const WEBHOOK_DETAILS_BUSINESS_UNIT_TEST_ID =
  'developers_webhooks_details_business-unit-label';
export const WEBHOOK_DETAILS_UUID_TEST_ID =
  'developers_webhooks_details_uuid-label';
export const WEBHOOK_DETAILS_EVENT_TEST_ID =
  'developers_webhooks_details_event-label';
export const WEBHOOK_DETAILS_CREATED_BY_TEST_ID =
  'developers_webhooks_details_created-by-label';
export const WEBHOOK_DETAILS_CREATED_AT_TEST_ID =
  'developers_webhooks_details_created-at-label';
export const WEBHOOK_DETAILS_DEACTIVATE_TEST_ID =
  'developers_webhooks_details_deactivate-btn';
export const WEBHOOK_DETAILS_ACTIVATE_TEST_ID =
  'developers_webhooks_details_activate-btn';
export const WEBHOOK_DETAILS_EDIT_TEST_ID =
  'developers_webhooks_details_edit-btn';

export const EDIT_WEBHOOK_FORM_TEST_ID = 'developers_webhooks_edit';
export const EDIT_WEBHOOK_CLOSE_TEST_ID = 'developers_webhooks_edit_close-btn';
export const EDIT_WEBHOOK_ENDPOINT_TEST_ID =
  'developers_webhooks_edit_endpoint-input';
export const EDIT_WEBHOOK_ENDPOINT_ERROR_TEST_ID =
  'developers_webhooks_edit_endpoint-error';
export const EDIT_WEBHOOK_BUSINESS_UNIT_TEST_ID =
  'developers_webhooks_edit_business-unit-select';
export const EDIT_WEBHOOK_BUSINESS_UNIT_OPTION_TEST_ID = (uuid: string) =>
  `developers_webhooks_edit_business-unit-option-${uuid}`;
export const EDIT_WEBHOOK_X_AUTH_TEST_ID =
  'developers_webhooks_edit_x-auth-uuid-select';
export const EDIT_WEBHOOK_X_AUTH_OPTION_TEST_ID = (uuid: string) =>
  `developers_webhooks_edit_x-auth-uuid-option-${uuid}`;
export const EDIT_WEBHOOK_X_AUTH_ERROR_TEST_ID =
  'developers_webhooks_edit_x-auth-uuid-error';
export const EDIT_WEBHOOK_STATUS_TOGGLE_TEST_ID =
  'developers_webhooks_edit_status-checkbox';
export const EDIT_WEBHOOK_STATUS_LABEL_TEST_ID =
  'developers_webhooks_edit_status-label';
export const EDIT_WEBHOOK_WARNING_TEST_ID =
  'developers_webhooks_edit_inactive-warning';
export const EDIT_WEBHOOK_CANCEL_TEST_ID =
  'developers_webhooks_edit_cancel-btn';
export const EDIT_WEBHOOK_SUBMIT_TEST_ID =
  'developers_webhooks_edit_submit-btn';

export const EDIT_WEBHOOK_TITLE = 'Edit webhook';
export const INACTIVE_WARNING =
  'This webhook is currently inactive — events will not be delivered to this endpoint.';
export const AUTH_SCHEMA_DISABLED_ERROR = 'Authentication schema disabled';

export const WEBHOOK_DETAILS_READONLY_NOTE_TEST_ID =
  'developers_webhooks_details_readonly-note-label';

export const WEBHOOK_CREATED_BY_TENANT = `${tenant.name.company} support`;
export const WEBHOOK_CREATED_BY_ORG = 'Your organisation';

export const WEBHOOK_MANAGED_BY_TENANT = `This webhook is delivered over a channel managed by ${tenant.name.company} and can’t be edited here.`;

export const webhookCreatorLabel = (creatorType: WebhookCreatorType) =>
  creatorType === 'Admin::User'
    ? WEBHOOK_CREATED_BY_TENANT
    : WEBHOOK_CREATED_BY_ORG;
